import React from 'react';
import './configuration.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Configuración'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
